import { rHandler } from '@/plugins/RHandler';
import BaseModel from '../../../../base';

import constants from './constants';
import functions from './functions';
import glossary from './glossary';

import TournamentStageGroupMemberHistory from './history/index';
import { apiService } from '@/services/APIService';
import { DEFAULT_PARAMS } from '@/utils/objectsRHandler';

export default class TournamentStageGroupMember extends BaseModel {
  constructor(member = {}, url) {
    super(member, url);

    this.avatar = member.avatar;
    this.full_name = member.full_name;
    this.score = member.score;
    this.username = member.username;
    this.status = member.status || constants.TOURNAMENT_MEMBER_STATUS.waited;

    this.description = member.description || '';

    this.history = (member.history || [])
      .sort((a, b) => new Date(a.created_at) - new Date(b.created_at))
      .map((item) => new TournamentStageGroupMemberHistory(item));
  }

  get lastHistory() {
    const { TOURNAMENT_MEMBER_STATUS: { transfered } } = constants;
    return this.history.filter((i) => i.status !== transfered).at(-1);
  }

  update(rParams = DEFAULT_PARAMS) {
    const { data, obs } = rParams;
    const { lastHistory, score, description, status } = this;
    const currentData = {
      score,
      description,
      status,
      ...data,
    };
    const payload = {
      users: [
        {
          user_id: this.id,
          ...currentData,
        },
      ],
    };
    return rHandler(
      apiService.post(`tournament-stage-groups/${lastHistory?.tournament_stage_group_id}/users/score`, payload),
      (response) => {
        Object.assign(this, currentData);
        return { response };
      },
      (error) => ({ error }),
      obs,
    );
  }

  finish() {
    return this.update({
      data: {
        status: constants.TOURNAMENT_MEMBER_STATUS.ended,
      },
    });
  }

  resume() {
    return this.update({
      data: {
        status: constants.TOURNAMENT_MEMBER_STATUS.waited,
      },
    });
  }

  get isTranfered() {
    const { TOURNAMENT_MEMBER_STATUS: { transfered } } = constants;
    const { status } = this;
    return status === transfered;
  }

  get statusData() {
    const { TOURNAMENT_MEMBER_STATUS: { transfered } } = constants;
    const { TOURNAMENT_MEMBER_STATUS_DATA } = glossary;
    const { status } = this;
    const data = TOURNAMENT_MEMBER_STATUS_DATA[status];
    if (status === transfered) {
      const { lastHistory } = this;
      return {
        ...data,
        name: [
          'Переведён',
          ...lastHistory ? [`в ${lastHistory.tournament_stage.name} (${lastHistory.tournament_stage_group.name})`] : [],
        ].join(' '),
      };
    }
    return data;
  }

  // statusDataByGroup(groupId) {
  //   const { TOURNAMENT_MEMBER_STATUS: { transfered } } = constants;
  //   const { TOURNAMENT_MEMBER_STATUS_DATA } = glossary;
  //   const { status } = this;
  //   const data = TOURNAMENT_MEMBER_STATUS_DATA[status];
  //   if (status === transfered) {
  //     const nextHistory = this.history.find(({ parent_tournament_stage_group_id: id }) => id === groupId);
  //     return {
  //       ...data,
  //       name: [
  //         'Переведён',
  //         ...nextHistory ? [`в ${nextHistory.tournament_stage.name} (${nextHistory.tournament_stage_group.name})`] : [],
  //       ].join(' '),
  //     };
  //   }
  //   return data;
  // }

  get actions() {
    return functions.getActionsByStatus(this.status);
  }

  static get constants() {
    return constants;
  }

  static get glossary() {
    return glossary;
  }

  static get functions() {
    return functions;
  }
}
